import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
// Custom components
import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { IoSearchOutline } from 'react-icons/io5';
import {
    addAdmin,
    deleteAdmin,
    getAdmin,
    searchAdmin,
    updateAdmin,
} from '../redux/actions/Master.action';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { allBranchDetail } from '../redux/actions/Files.action';
import { addReferral, deleteReferral, getReferral, updateReferral } from '../redux/actions/Admin.action';

export default function Referral() {
    const [show, setShow] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [branchId, setBranchId] = useState();

    const toggle = () => {
        setShow(!show);
    };
    const updateToggle = () => {
        setUpdateModal(!updateModal);
    };
    const deleteToggle = () => {
        setDeleteModal(!deleteModal);
    };

    const dispatch = useDispatch();
    const getReferrals = useSelector((state) => state.admin);

    const initialValues = {
        discountPercentage: "",
        coins: ""
    }

    const validationSchema = Yup.object().shape({
        discountPercentage: Yup.string().required('Discount is required'),
        coins: Yup.string().required('Coin is required')
    });

    const [formData, setFormData] = useState({
        discountPercentage: "",
        coins: ""
    });

    const handleReferral = (values, { resetForm }) => {

        dispatch(addReferral(values)).then(() => {
            toggle();
            resetForm();
        });
    };

    const handleUpadteProblam = (values) => {
        const payload = {
            discountPercentage: values.discountPercentage,
            coins: values.coins
        };
        dispatch(updateReferral(branchId, payload)).then(() => {
            setUpdateModal(false);
        });
    };

    const handleDeleteProblam = () => {
        dispatch(deleteReferral(branchId)).then(() => {
            deleteToggle();
        });
    };

    useEffect(() => {
        dispatch(getReferral());
    }, []);

    return (
        <>
            <div className="mt-[100px] d-flex justify-content-end">
                <div className="d-flex items-center gap-3">                    
                    <Button
                        onClick={toggle}
                        className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                    >
                        <IoMdAdd className="mt-1 gap-1" />
                        Add Referral
                    </Button>
                </div>
            </div>
            <div className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between mt-5'>
                    <h3 className='fw-bold'>Referral</h3>
                </div>
                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Discount</Th>
                                <Th>Coins</Th>
                                <Th style={{ minWidth: '200px' }} className="text-end">Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {getReferrals?.getReferral?.data?.data?.length > 0 ? (
                                getReferrals?.getReferral?.data?.data?.map((res) => {
                                    return (
                                        <Tr key={res._id}>
                                            <Td>{res.discountPercentage}</Td>
                                            <Td>{res.coins}</Td>
                                            <Td>
                                                <div className="d-flex gap-3 justify-end">
                                                    <FaEdit
                                                        onClick={() => {
                                                            updateToggle();
                                                            setFormData(res);
                                                            setBranchId(res._id);
                                                        }}
                                                        className="cursor-pointer border-green-color fs-5 text-success"
                                                        title="update"
                                                    />
                                                    <MdDelete
                                                        onClick={() => {
                                                            deleteToggle();
                                                            setBranchId(res._id);
                                                        }}
                                                        className="cursor-pointer border-green-color fs-5 text-danger"
                                                        title="delete"
                                                    />
                                                </div>
                                            </Td>
                                        </Tr>
                                    );
                                })
                            ) : (
                                <>
                                    <Tr>
                                        <Td colSpan={3} textAlign='center'>Code Not Found</Td>
                                    </Tr>
                                </>
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>

            {/* add problem */}

            <Modal show={show} onHide={toggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Referral</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleReferral}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Discount</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="discountPercentage"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('discountPercentage', e.target.value)}
                                                value={values.discountPercentage}
                                                placeholder="Enter Discount"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="discountPercentage"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Coins</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="coins"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('coins', e.target.value)}
                                                value={values.coins}
                                                placeholder="Enter Coins"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="coins"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* update problem */}

            <Modal show={updateModal} onHide={updateToggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Referral</Modal.Title>
                </Modal.Header>
                <Formik
                    enableReinitialize={true}
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpadteProblam}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Discount</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="discountPercentage"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('discountPercentage', e.target.value)}
                                                value={values.discountPercentage}
                                                placeholder="Enter Discount"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="discountPercentage"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Coins</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="coins"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('coins', e.target.value)}
                                                value={values.coins}
                                                placeholder="Enter Coins"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="coins"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={updateToggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Update
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* delete problem */}

            <Modal show={deleteModal} onHide={deleteToggle}>
                <Modal.Body className='p-5'>
                    <div>
                        <PiWarningCircleBold className='text-7xl w-100 text-danger' />
                    </div>
                    <div className='text-center mt-4'>
                        <h3>Are You Sure ?</h3>
                        <p className='text-md'>Do you really want to delete these records?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDeleteProblam}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
